/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pick_TCTemplateTrigger_id_ } from './Pick_TCTemplateTrigger_id_';
import type { TCTemplateKind } from './TCTemplateKind';
/**
 * TSOA-compatible template summary.
 */
export type TCTemplateSummary = {
    origin?: string;
    key?: string;
    name?: string;
    description?: string;
    version?: number;
    tags?: Array<string>;
    createdAt?: string;
    updatedAt?: string;
    templateId?: string;
    author?: string;
    references?: Array<{
        required?: boolean;
        alias?: string;
        version: number;
        key: string;
    }>;
    definitionLocation?: ({
        sizeBytes: number;
        type: TCTemplateSummary.type;
    } | {
        s3Key: string;
        s3Bucket: string;
        sizeBytes: number;
        type: TCTemplateSummary.type;
    });
    /**
     * Template kind identifier.
     */
    kind: TCTemplateKind;
    /**
     * Optional trigger reference containing only the trigger id.
     */
    trigger?: Pick_TCTemplateTrigger_id_;
};
export namespace TCTemplateSummary {
    export enum type {
        INLINE = 'inline',
    }
}

